
<div class="flex h-screen w-full bg-[#FDFBF7]">
  
  <!-- LEFT PANEL: Strategy Configuration -->
  <aside class="w-[400px] border-r border-stone-200 overflow-y-auto bg-white flex flex-col shadow-lg z-10 shrink-0">
    <div class="p-6 bg-[#6F4E37] text-white sticky top-0 z-20 shadow-md">
      <div class="flex justify-between items-center mb-1">
        <h1 class="text-xl font-bold flex items-center gap-2">
          <span>⚙️</span> Pasu Coffee Strategy
        </h1>
        <button (click)="toggleTutorial()" class="text-xs bg-white/20 hover:bg-white/30 px-2 py-1 rounded-full transition">
          ? วิธีเล่น
        </button>
      </div>
      <p class="text-stone-200 text-xs">บริหารจัดการต้นทุนและกลยุทธ์เกม</p>
      
      <!-- Budget Preview in Header -->
      <div class="mt-4 bg-[#5D4030] rounded-lg p-3">
        <div class="flex justify-between text-xs text-stone-300 mb-1">
          <span>งบประมาณที่ต้องใช้ (Est. Cost)</span>
          <span [class.text-red-300]="!canAfford()">฿{{ totalWeeklyCost() | number }}</span>
        </div>
        <div class="w-full bg-stone-700 h-2 rounded-full overflow-hidden">
          <div class="h-full transition-all duration-300"
               [style.width.%]="(totalWeeklyCost() / gameState().money) * 100"
               [class.bg-green-400]="canAfford()"
               [class.bg-red-500]="!canAfford()">
          </div>
        </div>
        <div class="flex justify-between text-xs mt-1">
          <span class="text-stone-400">เงินที่มี: ฿{{ gameState().money | number }}</span>
          <span class="font-bold" [class.text-red-300]="!canAfford()" [class.text-green-300]="canAfford()">
            {{ canAfford() ? 'พอจ่าย' : 'เงินไม่พอ' }}
          </span>
        </div>
      </div>
    </div>

    <div class="p-6 space-y-6 pb-28">
      
      <!-- Loop through configuration sections -->
      <!-- 1. Goal -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">1. เป้าหมาย (Goal)</label>
        <select [ngModel]="selectedGoal()" (ngModelChange)="selectedGoal.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of goalOptions; track opt.value) {
            <option [ngValue]="opt">
              {{ opt.label }} (฿{{ opt.cost }})
            </option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedGoal().cost }}</div>
      </section>

      <!-- 2. Rules -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">2. กฎ (Rules)</label>
        <select [ngModel]="selectedRule()" (ngModelChange)="selectedRule.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of ruleOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedRule().cost }}</div>
      </section>

      <!-- 3. Conflict -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">3. ความขัดแย้ง (Conflict)</label>
        <select [ngModel]="selectedConflict()" (ngModelChange)="selectedConflict.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of conflictOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedConflict().cost }}</div>
      </section>

      <!-- 4. Time -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">4. เวลา (Time)</label>
        <select [ngModel]="selectedTime()" (ngModelChange)="selectedTime.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of timeOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedTime().cost }}</div>
      </section>

      <!-- 5. Reward -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">5. รางวัล (Reward)</label>
        <select [ngModel]="selectedReward()" (ngModelChange)="selectedReward.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of rewardOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedReward().cost }}</div>
      </section>

      <!-- 6. Feedback -->
      <section class="border-b border-stone-100 pb-4">
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">6. ผลป้อนกลับ (Feedback)</label>
        <select [ngModel]="selectedFeedback()" (ngModelChange)="selectedFeedback.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of feedbackOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedFeedback().cost }}</div>
      </section>

      <!-- 7. Levels -->
      <section>
        <label class="block text-[#6F4E37] font-bold mb-2 text-sm">7. ระดับ (Levels)</label>
        <select [ngModel]="selectedLevel()" (ngModelChange)="selectedLevel.set($event)" class="w-full p-2 text-sm border border-stone-300 rounded bg-stone-50 outline-none focus:border-[#6F4E37]">
          @for (opt of levelOptions; track opt.value) {
            <option [ngValue]="opt">{{ opt.label }} (฿{{ opt.cost }})</option>
          }
        </select>
        <div class="text-right text-xs text-stone-400 mt-1">Cost: ฿{{ selectedLevel().cost }}</div>
      </section>

    </div>

    <!-- Sticky Action Bar -->
    <div class="sticky bottom-0 bg-white p-4 border-t border-stone-200 shadow-lg">
      <button 
        (click)="runSimulation()" 
        [disabled]="isLoading() || !canAfford() || gameStatus() !== 'playing'"
        class="w-full py-4 font-bold rounded-xl shadow-lg transform transition active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-white"
        [class.bg-green-700]="canAfford() && gameStatus() === 'playing'"
        [class.hover:bg-green-800]="canAfford() && gameStatus() === 'playing'"
        [class.bg-stone-500]="!canAfford() || gameStatus() !== 'playing'">
        @if (isLoading()) {
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          กำลังดำเนินการ...
        } @else {
          <div class="flex flex-col items-center leading-tight">
            <span>🚀 ลงทุนและเริ่มเกม</span>
            <span class="text-xs font-normal opacity-90">-฿{{ totalWeeklyCost() | number }}</span>
          </div>
        }
      </button>
    </div>
  </aside>

  <!-- RIGHT PANEL: Dashboard -->
  <main class="flex-1 flex flex-col h-screen overflow-hidden relative bg-[#F4F1EA]">
    <!-- Header Stats -->
    <header class="bg-white p-6 shadow-sm border-b border-stone-200 grid grid-cols-4 gap-4 z-10">
      <div class="flex flex-col justify-center">
        <div class="text-4xl">{{ currentShopIcon() }}</div>
        <span class="text-xs text-stone-500 font-bold mt-1">{{ currentLevelTitle() }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-stone-400 text-xs uppercase tracking-wider font-bold">เงินทุน (Capital)</span>
        <span class="text-3xl font-bold tracking-tight" [class.text-green-700]="gameState().money >= 0" [class.text-red-700]="gameState().money < 0">฿{{ gameState().money | number }}</span>
        <span class="text-xs text-stone-400">สภาพคล่อง</span>
      </div>
      <div class="flex flex-col">
        <span class="text-stone-400 text-xs uppercase tracking-wider font-bold">ลูกค้า (Total Customers)</span>
        <span class="text-2xl font-bold text-blue-700">{{ gameState().totalCustomers | number }}</span>
        <span class="text-xs text-stone-400">คน</span>
      </div>
      <div class="flex flex-col">
        <span class="text-stone-400 text-xs uppercase tracking-wider font-bold">ชื่อเสียง (Reputation)</span>
        <div class="flex items-center gap-2 mt-1">
          <div class="flex-1 h-3 bg-stone-200 rounded-full overflow-hidden">
            <div class="h-full bg-yellow-500 transition-all duration-1000" [style.width]="getReputationWidth()"></div>
          </div>
          <span class="text-sm font-bold">{{ gameState().reputation }}/10</span>
        </div>
      </div>
    </header>

    <!-- Main Content Area -->
    <div class="flex-1 overflow-y-auto p-8 relative">
      <div class="max-w-3xl mx-auto">
        
        <!-- Welcome / Empty State -->
        @if (gameState().history.length === 0) {
          <div class="text-center py-20 opacity-60">
            <div class="text-8xl mb-6">☕</div>
            <h2 class="text-3xl font-bold text-stone-700 mb-2">ยินดีต้อนรับสู่ Pasu Coffee</h2>
            <p class="text-stone-500 max-w-lg mx-auto leading-relaxed">
              เป้าหมายของคุณคือขยายกิจการจาก <span class="font-bold text-stone-700">รถเข็น</span> สู่ <span class="font-bold text-stone-700">อาณาจักรกาแฟ</span>
              <br>โดยการใช้ <span class="text-[#6F4E37] font-bold">7 องค์ประกอบ Gamification</span>
              <br><br>
              ⚠️ <span class="font-bold">ระวัง!</span> ทุกกลยุทธ์มีต้นทุน เลือกให้ฉลาดเพื่อให้ได้กำไรสูงสุด
            </p>
            <button (click)="toggleTutorial()" class="mt-6 px-6 py-2 bg-[#6F4E37] text-white rounded-lg shadow hover:bg-[#5D4030] transition">
              อ่านกติกาการเล่น
            </button>
          </div>
        }

        <!-- History Feed -->
        <div class="space-y-6 pb-20">
          @for (log of gameState().history.slice().reverse(); track log.day) {
            <div class="bg-white rounded-2xl p-6 shadow-sm border border-stone-100 fade-in relative overflow-hidden group hover:shadow-md transition">
              <!-- Visual Indicator for Profit/Loss -->
              <div class="absolute left-0 top-0 bottom-0 w-2" 
                   [class.bg-green-500]="log.profit > 0" 
                   [class.bg-red-500]="log.profit <= 0">
              </div>

              <div class="flex justify-between items-start mb-4 border-b border-stone-100 pb-4 pl-4">
                <div>
                  <h3 class="font-bold text-lg text-[#6F4E37]">สัปดาห์ที่ {{ log.day / 7 | number:'1.0-0' }}</h3>
                  <p class="text-xs text-stone-400">สถานะ: {{ log.profit > 0 ? 'กำไร (Profit)' : 'ขาดทุน (Loss)' }}</p>
                </div>
                <div class="text-right">
                  <div class="flex flex-col items-end">
                    <span class="text-xs text-stone-400">Net Profit</span>
                    <span class="text-2xl font-bold" [class.text-green-600]="log.profit > 0" [class.text-red-600]="log.profit <= 0">
                      {{ log.profit > 0 ? '+' : '' }}฿{{ log.profit | number }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pl-4">
                <div>
                  <div class="flex justify-between mb-2 text-sm text-stone-500">
                    <span>รายรับ (Revenue):</span>
                    <span class="text-stone-700">฿{{ log.revenue | number }}</span>
                  </div>
                  <div class="flex justify-between mb-4 text-sm text-stone-500">
                    <span>ต้นทุน (Cost):</span>
                    <span class="text-red-400">-฿{{ log.cost | number }}</span>
                  </div>
                  
                  <h4 class="font-bold text-xs uppercase text-stone-400 mb-2">บทวิเคราะห์</h4>
                  <div class="bg-stone-50 p-3 rounded text-sm text-stone-600 italic border-l-2 border-stone-300">
                     {{ log.analysis }}
                  </div>
                </div>
                
                <div>
                   <h4 class="font-bold text-xs uppercase text-stone-400 mb-2">Feedback ลูกค้า</h4>
                   <ul class="space-y-2">
                    @for (review of log.reviews; track $index) {
                      <li class="text-sm text-stone-600 flex gap-2">
                        <span>💬</span> "{{ review }}"
                      </li>
                    }
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </main>

  <!-- TUTORIAL MODAL -->
  @if (showTutorial()) {
    <div class="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm fade-in">
      <div class="bg-white rounded-2xl shadow-2xl max-w-2xl w-full overflow-hidden max-h-[90vh] flex flex-col">
        <div class="bg-[#6F4E37] p-6 text-white flex justify-between items-center shrink-0">
          <h2 class="text-2xl font-bold">📜 กติกาและแนวคิดเกม (Game Rules)</h2>
          <button (click)="toggleTutorial()" class="text-white/70 hover:text-white text-2xl">&times;</button>
        </div>
        
        <div class="p-8 overflow-y-auto">
          <p class="text-stone-600 mb-6">ยินดีต้อนรับสู่ <strong>Pasu Coffee Gamification Master</strong> เกมจำลองการบริหารธุรกิจที่คุณต้องใช้จิตวิทยาเกมเพื่อดึงดูดลูกค้า!</p>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div class="bg-green-50 p-4 rounded-xl border border-green-100">
              <h3 class="font-bold text-green-800 mb-2">🏆 เป้าหมาย (Goal)</h3>
              <p class="text-sm text-stone-600">บริหารเงินทุนให้งอกเงย และพาชื่อเสียงร้าน (Reputation) ไปให้ถึง <span class="font-bold">ระดับ 10</span> เพื่อเป็นเจ้าแห่งกาแฟ</p>
            </div>
            <div class="bg-red-50 p-4 rounded-xl border border-red-100">
              <h3 class="font-bold text-red-800 mb-2">💀 กฎการแพ้ (Lose Condition)</h3>
              <p class="text-sm text-stone-600">หากเงินทุน (Money) ของคุณ <span class="font-bold text-red-600">ติดลบ</span> เกมจะจบทันที (Game Over)</p>
            </div>
          </div>

          <h3 class="font-bold text-stone-800 mb-3 border-b pb-2">🧩 แนวคิด 7 องค์ประกอบ (The 7 Elements)</h3>
          <ul class="space-y-3 text-sm text-stone-700">
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">1</span>
              <div><strong class="text-[#6F4E37]">เป้าหมาย (Goal):</strong> ต้องชัดเจนว่าลูกค้าทำอะไรแล้วจะได้อะไร</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">2</span>
              <div><strong class="text-[#6F4E37]">กฎ (Rules):</strong> ข้อจำกัดสร้างความท้าทาย แต่ถ้ายากไปลูกค้าจะหนี</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">3</span>
              <div><strong class="text-[#6F4E37]">ความขัดแย้ง (Conflict):</strong> การแข่งขัน หรือความร่วมมือ กระตุ้นให้เกมน่าสนใจ</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">4</span>
              <div><strong class="text-[#6F4E37]">เวลา (Time):</strong> ความเร่งด่วน (Urgency) กระตุ้นการตัดสินใจซื้อ</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">5</span>
              <div><strong class="text-[#6F4E37]">รางวัล (Reward):</strong> สิ่งตอบแทนที่คุ้มค่ากับความพยายาม</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">6</span>
              <div><strong class="text-[#6F4E37]">ผลป้อนกลับ (Feedback):</strong> บอกให้รู้ว่าลูกค้าเข้าใกล้เป้าหมายแค่ไหนแล้ว</div>
            </li>
            <li class="flex gap-3">
              <span class="bg-stone-200 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold shrink-0">7</span>
              <div><strong class="text-[#6F4E37]">ระดับ (Levels):</strong> แสดงความก้าวหน้าจากมือใหม่สู่แฟนพันธุ์แท้</div>
            </li>
          </ul>

          <div class="mt-8 text-center">
            <button (click)="toggleTutorial()" class="bg-[#6F4E37] hover:bg-[#5D4030] text-white px-8 py-3 rounded-xl font-bold transition shadow-lg">
              เข้าใจแล้ว! เริ่มบริหารร้านเลย
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ROUND RESULT MODAL -->
  @if (showResultModal()) {
    <div class="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm fade-in">
      <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all scale-100">
        
        <!-- HEADER: Dynamic based on game status -->
        @if (gameStatus() === 'playing') {
          <div class="p-6 text-white text-center relative overflow-hidden" 
               [class.bg-green-600]="lastResult()?.profit > 0"
               [class.bg-red-600]="lastResult()?.profit <= 0">
            <h2 class="text-3xl font-bold mb-1 relative z-10">
              {{ lastResult()?.profit > 0 ? '🎉 กำไร!' : '💸 ขาดทุน!' }}
            </h2>
            <p class="text-white/90 relative z-10 text-sm">ผลประกอบการสัปดาห์นี้</p>
          </div>
        } @else if (gameStatus() === 'won') {
          <div class="p-6 bg-yellow-500 text-white text-center">
            <h2 class="text-3xl font-bold mb-1">🏆 ผู้ชนะ!</h2>
            <p>คุณคือตำนานแห่งวงการกาแฟ</p>
          </div>
        } @else {
           <div class="p-6 bg-stone-800 text-white text-center">
            <h2 class="text-3xl font-bold mb-1">☠️ ล้มละลาย</h2>
            <p>เงินทุนหมดเกลี้ยง...</p>
          </div>
        }
        
        <div class="p-6">
          <!-- Stats -->
          <div class="flex flex-col gap-2 mb-6 text-center">
            <span class="text-stone-400 text-sm">กำไรสุทธิ (Net Profit)</span>
            <span class="text-5xl font-bold text-stone-800"
                  [class.text-green-600]="lastResult()?.profit > 0"
                  [class.text-red-600]="lastResult()?.profit <= 0">
              {{ lastResult()?.profit > 0 ? '+' : '' }}{{ lastResult()?.profit | number }}
            </span>
            <span class="text-xs text-stone-400 mt-2">
              (รายได้ ฿{{ lastResult()?.revenue | number }} - ต้นทุน ฿{{ lastResult()?.cost | number }})
            </span>
          </div>

          <!-- Analysis -->
          <div class="bg-stone-50 p-4 rounded-xl border border-stone-100 mb-6 text-sm text-stone-600">
             <span class="font-bold block mb-1 text-stone-800">💡 ผู้เชี่ยวชาญแนะนำ:</span>
             {{ lastResult()?.educationalAnalysis }}
          </div>

          <!-- Action Button -->
          @if (gameStatus() === 'playing') {
            <button (click)="closeModal()" class="w-full py-3 bg-stone-800 text-white rounded-xl font-bold hover:bg-stone-900 transition shadow-lg">
              ไปต่อสัปดาห์หน้า
            </button>
          } @else {
             <button (click)="restartGame()" class="w-full py-3 bg-[#6F4E37] text-white rounded-xl font-bold hover:bg-[#5D4030] transition shadow-lg animate-pulse">
              🔄 เริ่มเกมใหม่
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
